export const TRANSMISSION_TABLE_ALLOWED_SORTING_COLUMNS = [
  "date",
  "account",
  "reportNotes",
  "name",
  "assignedPhysician",
];

export const STORAGE_TO_TRANSMISSION_TABLE_KEY = {
  report_date: "date",
  account: "account",
  alert_priority: "reportNotes",
};

export const TRANSMISSION_TABLE_TO_STORAGE_KEY = {
  date: "report_date",
  account: "account",
  reportNotes: "alert_priority",
};
